import React, { forwardRef, ForwardRefRenderFunction, InputHTMLAttributes, useImperativeHandle, useRef } from 'react';

import { styles } from './styles';

type InputProps = InputHTMLAttributes<HTMLInputElement>;
export type InputRef = { focus: () => void };

const InputBase: ForwardRefRenderFunction<InputRef, InputProps> = (props, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => ({
    focus: () => {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.select();
        }
      });
    },
  }));

  return <input ref={inputRef} css={styles} {...props} />;
};

export const Input = forwardRef(InputBase);
